import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrListCertificateOptionsPathParameters } from 'api/actions/hr-list-certificate-options/hr-list-certificate-options-path-parameters';
import { HrListCertificateOptionsResponse } from 'api/actions/hr-list-certificate-options/hr-list-certificate-options-response';

type HrListCertificateOptionsQueryParameters = Record<string, any>;

/**
 * The path of the HrListCertificateOptions action.
 */
export const hrListCertificateOptionsActionPath = new SweetPath<keyof HrListCertificateOptionsPathParameters>(
  '/api/hr/terms/{termId}/certificate-options',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrListCertificateOptions actions.
 */
export default function createHrListCertificateOptionsAction(axios: AxiosInstance) {
  return function hrListCertificateOptionsAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrListCertificateOptionsPathParameters;
    query?: HrListCertificateOptionsQueryParameters;
  }) {
    const path = hrListCertificateOptionsActionPath.insert(parameters);

    return axios.request<HrListCertificateOptionsResponse, HrListCertificateOptionsResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
